// extracted by mini-css-extract-plugin
export default {"fwLogo":"LeftBar_fwLogo__tmBTm"};